(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   * A service that provides a way to fetch, set, and clear the currently
   * logged in user. Essentially, this is a session provider.
   **/
  factory('User', ['Logger', '$cookies', '$window', function (Logger, $cookies, $window) {
    return {
      // Protect against cookies shared between *.domain.com
      // and domain.com (root) in IE by using host in cookie name
      cookieName: "user",
      user: null,
      set: function set(user) {
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        $cookies.put(this.cookieName, JSON.stringify(user), {
          expires: tomorrow,
          secure: location.protocol === "https:"
        });
        this.user = user;
      },
      get: function get() {
        if (this.user === null) {
          var strVal = $cookies.get(this.cookieName);
          if (strVal) {
            try {
              var user = JSON.parse(strVal);
              this.user = user;
            } catch (e) {
              Logger.warn("Unexpected user representation: '" + strVal + "'");
              this.user = null;
            }
          }
        }
        return this.user || {
          unauthenticated: true,
          subject: {
            roles: []
          }
        };
      },
      clear: function clear() {
        $cookies.remove(this.cookieName);
        $cookies.remove('wsXSRFToken');
        $cookies.remove('wsImpersonatedUser');
        this.clearGlobalLastActivity();
        this.user = null;
      },
      belongsToSingleOrg: function belongsToSingleOrg() {
        return this.user.belongsToSingleOrg;
      },
      setBelongsToSingleOrg: function setBelongsToSingleOrg(value) {
        this.user.belongsToSingleOrg = !!value;
        this.set(this.user);
      },
      getGlobalLastActivity: function getGlobalLastActivity() {
        return $window.localStorage.getItem("ws-user-last-activity");
      },
      setGlobalLastActivity: function setGlobalLastActivity(lastActivity) {
        return $window.localStorage.setItem("ws-user-last-activity", lastActivity);
      },
      clearGlobalLastActivity: function clearGlobalLastActivity() {
        return $window.localStorage.removeItem("ws-user-last-activity");
      }
    };
  }]);
})();
